import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        name: ""
      },
      dialogVisible: false // 弹窗状态
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getData: function getData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getCurrencyUnitList();
            case 1:
              res = _context2.v;
              _this2.tableData = res.data;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              res = null;
              if (!_this3.form.id) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return _this3.$api.updateCurrencyUnit(_this3.form);
            case 1:
              res = _context3.v;
              _context3.n = 4;
              break;
            case 2:
              _context3.n = 3;
              return _this3.$api.addCurrencyUnit(_this3.form);
            case 3:
              res = _context3.v;
            case 4:
              _this3.dialogVisible = false;
              _this3.form = {};
              _this3.getData();
            case 5:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};